
import { renderTabPanel as renderTabPanelLayers } from '../../map';
import { 
    renderTabPanelHome,
    renderTabPanelUser 
} from '../../core';
import { renderTabPanel as renderTabPanelData } from '../../data';
import { renderTabPanel as renderTabPanelMeasurement } from '../../measurement';
import { renderTabPanel as renderTabPanelPrint } from '../../print';
import { renderTabPanel as renderTabPanelSearch } from '../../search';
import { renderTabPanel as renderTabPanelShare } from '../../share';

const canUseTabPanel = (appModules, availablePanels, moduleId, defaultUse = true) => {
    let canUse = defaultUse;
    if (appModules.indexOf(moduleId) !== -1) {
        canUse = true;
    }
    canUse = canUse && isPanelAvailable(availablePanels, moduleId);
    return canUse;
}

const canUseTabPanelHome = (availablePanels) => {
    return isPanelAvailable(availablePanels, 'home');
}

const canUseTabPanelUser = (availablePanels, existsUser) => {
    return (existsUser) && isPanelAvailable(availablePanels, 'user');
}

const canUseTabPanelLayers = (availablePanels, existsMap) => {
    return (existsMap) && isPanelAvailable(availablePanels, 'layer');
}

const isPanelAvailable = (availablePanels, id) => {
    return (availablePanels.indexOf(id) !== -1);
}

export default function getTabsModule(appModules, availablePanels, existsMap, existsUser) {

    let tabs = [];

    if (canUseTabPanelHome(availablePanels)) {
        tabs.push({name: 'home', iconName: 'Home', title: 'Úvod', renderTabPanelFunc: renderTabPanelHome});
    }
    if (canUseTabPanelLayers(availablePanels, existsMap)) {
        tabs.push({name: 'layers', iconName: 'MapLayers', title: 'Seznam vrstev', renderTabPanelFunc: renderTabPanelLayers});
    }
    if (canUseTabPanel(appModules, availablePanels, 'data', false)) {
        tabs.push({name: 'data', iconName: 'CustomList', title: 'Datový panel', renderTabPanelFunc: renderTabPanelData});
    }
    if (canUseTabPanel(appModules, availablePanels, 'search', false)) {
        tabs.push({name: 'search', iconName: 'Search', title: 'Vyhledávání', renderTabPanelFunc: renderTabPanelSearch});
    }
    if (canUseTabPanel(appModules, availablePanels, 'measurement', false)) {
        tabs.push({name: 'measurement', iconName: 'Design', title: 'Měření', renderTabPanelFunc: renderTabPanelMeasurement});
    }
    if (canUseTabPanel(appModules, availablePanels, 'print', false)) {
        tabs.push({name: 'print', iconName: 'Print', title: 'Tisk', renderTabPanelFunc: renderTabPanelPrint});
    }
    if (canUseTabPanel(appModules, availablePanels, 'share', false)) {
        tabs.push({name: 'share', iconName: 'Share', title: 'Sdílení aktuálního stavu', renderTabPanelFunc: renderTabPanelShare});
    }
    if (canUseTabPanelUser(availablePanels, existsUser)) {
        tabs.push({name: 'user', iconName: 'Contact', title: 'Přihlášený uživatel', renderTabPanelFunc: renderTabPanelUser});
    }

    return tabs;
}
